var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class TokenLoginGateway {
    constructor(player, gateway, tokenValidator, loginRequestService, legacyLogin) {
        this.player = player;
        this.gateway = gateway;
        this.tokenValidator = tokenValidator;
        this.loginRequestService = loginRequestService;
        this.legacyLogin = legacyLogin;
    }
    login(parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const existingToken = yield this.gateway.getToken();
                if (!existingToken || this.tokenValidator.isAnonymous(existingToken)) {
                    const token = yield this.loginRequestService.getLoginToken(parameters);
                    this.gateway.setToken(token);
                    this.legacyLogin(this.player, parameters);
                }
            }
            catch (e) {
                this.player.processLoginError(e);
            }
        });
    }
}
//# sourceMappingURL=TokenLoginGateway.js.map